export default function ApplicationProcess() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            {/* Banner arriba de la foto */}
            <div className="mb-8 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 py-6 px-8 rounded-xl shadow-lg">
              <p className="text-2xl lg:text-3xl font-bold text-gray-900">
                Escapa del invierno, los impuestos altos y la incertidumbre migratoria
              </p>
            </div>
            
            <div className="mb-8">
              <img 
                src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/d1b622a8df541927a6e82f534dab3bf1.png" 
                alt="Proceso de solicitud de visado" 
                className="w-full max-w-3xl mx-auto rounded-2xl shadow-lg"
              />
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              ¿Cómo se presenta la solicitud?
            </h2>
            <p className="text-xl text-gray-700">
              Tienes dos caminos para obtener tu visado
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl shadow-lg p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mb-6">
                <i className="ri-map-pin-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                1. Solicitar desde España
              </h3>
              <p className="text-lg text-gray-700 mb-4">
                (como turista)
              </p>
              <div className="bg-white rounded-lg p-4 border-l-4 border-blue-600">
                <p className="text-lg font-semibold text-gray-900">
                  Obtendrás directamente una tarjeta de residencia.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-lg p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mb-6">
                <i className="ri-global-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                2. Solicitar desde tu país de origen
              </h3>
              <p className="text-lg text-gray-700 mb-4">
                (a través del consulado español previa asistencia del abogado)
              </p>
              <div className="bg-white rounded-lg p-4 border-l-4 border-green-600">
                <p className="text-lg font-semibold text-gray-900">
                  El consulado expedirá un visado de <strong>1 año</strong>, convertible luego en tarjeta de residencia.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-xl p-8 text-white mb-12">
            <div className="text-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-rocket-fill text-4xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4">Proceso rápido y eficiente</h3>
              <p className="text-xl mb-2">
                Los procesos se gestionan a través de la <strong>Unidad de Grandes Empresas (UGE)</strong>
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <p className="text-2xl font-bold">
                ⏱️ Resolución aproximada: <span className="text-yellow-300">20 días laborables</span>
              </p>
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              ¿Listo para comenzar tu proceso?
            </h3>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="#consulta" 
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Reservar Consulta
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
